import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const option: SxStyle = {
  borderColor: (p) => p.palette.grey[300],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(1, 1.5),
  gap: (p) => p.spacing(1.25),
};

export const imageWrapper: SxStyle = {
  position: 'relative',
};

export const creditTotal: SxStyle = {
  position: 'absolute',
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  top: (p) => p.spacing(16.75),
  right: (p) => p.spacing(12),
  px: 0.5,
  background: (p) => p.palette.common.white,
  color: (p) => p.palette.error[500],
};

export const creditRollover: SxStyle = {
  position: 'absolute',
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  top: '180px',
  right: (p) => p.spacing(12),
  px: 0.5,
  background: (p) => p.palette.common.white,
  color: (p) => p.palette.error[500],
};
